module.exports = __webpack_public_path__ + "static/employee-review-40315b96f7f260a22f2bdac21d21fe59.png";